export default __webpack_public_path__ + "static/media/newspaper.6429ccf2.svg";